import { type FC } from 'react';

import * as styles from './brand.css';
import { STREAMLAIN_CORE_LOGO } from './streamlain-logo-mark';

/** Static master geometry. Loader motion belongs to BrandLoader. */
export const StreamLainLogoMark: FC = () => {
  const renderPath = (layer: 'upper' | 'lower') => {
    const source = STREAMLAIN_CORE_LOGO.mark[layer];
    return (
      <g>
        <g transform={source.transform}>
          <path
            fill={`var(--sl-brand-mark-${layer}, ${layer === 'upper' ? STREAMLAIN_CORE_LOGO.colors.primary : STREAMLAIN_CORE_LOGO.colors.secondary})`}
            d={source.path}
          />
        </g>
      </g>
    );
  };

  return (
    <g className={styles.mark}>
      {renderPath('upper')}
      {renderPath('lower')}
    </g>
  );
};
